import Keycloak from 'keycloak-js';

const getKeycloakConfigFile = () => {
    const host = window.location.hostname;
    // Localhost must use the realm the backend's active profile trusts (sec.keycloak.iss).
    // The dev profile points at "avalosystest" — the realm that owns the av_alosys_test data
    // — while the deployed keycloak.json below still targets the old YouKey "ykbeta" realm.
    if (host.includes('localhost') || host === '127.0.0.1') return '/keycloak-local.json';

    return '/keycloak.json';
};

const kc = new Keycloak(process.env.PUBLIC_URL + getKeycloakConfigFile());

const doLogin = kc.login;

const doLogout = kc.logout;

const getToken = () => kc.token;

const isLoggedIn = () => !!kc.token;

const updateToken = (successCallback) => kc.updateToken(5)
    .then(successCallback)
    .catch(doLogin);

const getUsername = () => kc.tokenParsed?.preferred_username;
const getEmail = () => kc.tokenParsed?.email;

const hasRole = (role, client = "web-console") => {
    const resourceAccess = kc?.resourceAccess || {};
    const clientRoles = resourceAccess[client]?.roles || [];
    return clientRoles.includes(role);
};

const getTokenParsed = kc.tokenParsed;

const getNameSurnameInitials = () => `${kc.tokenParsed?.given_name[0]}${kc.tokenParsed?.family_name[0]}`;

const getInstance = kc;

/**
 * Initializes Keycloak instance and calls the provided
 * callback function if successfully authenticated.
 *
 * @param onAuthenticatedCallback
 */
const initKeycloak = (onAuthenticatedCallback) => {
    kc.init({
        onLoad: 'check-sso',
        flow: 'standard',
        checkLoginIframe: false,
        redirectUri: process.env.PUBLIC_URL,
    })
        .then((authenticated) => {
            if (authenticated) {
                onAuthenticatedCallback();
            } else {
                doLogin();
            }
        })
        .catch((err) => {
            console.error('Keycloak init failed', err);
        });
};

const KeycloakService = {
    initKeycloak,
    doLogin,
    doLogout,
    isLoggedIn,
    getToken,
    updateToken,
    getUsername,
    getEmail,
    hasRole,
    getTokenParsed,
    getInstance,
    getNameSurnameInitials,
};

export default KeycloakService;
